import { apiClient, ApiResponse } from './client';
import { FilterProfile } from '@/app/(protected)/filters/_components/types';

export async function getProfiles(sessionId: string): Promise<ApiResponse> {
  return apiClient.request({
    method: 'POST',
    url: '/instacart/profiles/get',
    data: { session_id: sessionId }
  });
}

export async function putProfile(
  sessionId: string, 
  profile: FilterProfile
): Promise<ApiResponse> {
  return apiClient.request({
    method: 'POST',
    url: '/instacart/profiles/put',
    data: { 
      session_id: sessionId,
      profile
    }
  });
}

export async function deleteProfile(
  sessionId: string, 
  profileId: string
): Promise<ApiResponse> {
  return apiClient.request({
    method: 'POST',
    url: '/instacart/profiles/delete',
    data: { 
      session_id: sessionId,
      profile_id: profileId
    }
  });
}

export async function getStoreAddresses(sessionId: string): Promise<ApiResponse> {
  return apiClient.request({
    method: 'POST',
    url: '/instacart/stores/addresses',
    data: { session_id: sessionId }
  });
}

export async function generateFilters(sessionId: string): Promise<ApiResponse> {
  return apiClient.request({
    method: 'POST',
    url: '/generate-filters',
    data: { session_id: sessionId }
  });
}
